import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import routes from "../../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    Item,
    Toolbar,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
    StateStoring,
    Editing,
    Lookup
} from "devextreme-react/data-grid";
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import { GridLayout } from "../../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button } from 'devextreme-react/button';
import RenderSelectBoxCell from "../../../../../common/RenderCell";
import { Popup } from "devextreme-react";
import { SerialNumberForm } from "../Layout";
import FormField from "../../../../../dynamicFormBuilder/FormField";
import Fields from "../../../../../dynamicFormBuilder/Fields";
import { Options, TransactionTypes } from "../../../../../enum/Enum";
import { OptionsNoYes } from "../../../../../const/constants";

function SerialNumbersTab(props) {
    const dataGrid = useRef(null);
    const allowedPageSizes = [10, 20, 100, 500, "all"];
    console.log(props.selectedRowData)
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [showSerialNumberForm, setShowSerialNumberForm] = useState(false);
    const initialFormFields = {
        Damageflag: null,
        Damagedescription: null,
        OriginalGrossWeight: null,
        OriginalNetWeight: null,
        Packageid: null,
        UserDefinedRefrence2: null,
        UserDefinedRefrence3: null,
        UserDefinedRefrence4: null,
        UserDefinedRefrence5: null,
        Comment: null,
        RowId: null,
        IsUpdateCall: false,
    }
    const [formFields, setformFields] = useState(initialFormFields);
    const flags = [
        {
            flagvalue: "Y",
            flagdescription: "Yes"
        },
        {
            flagvalue: "N",
            flagdescription: "No"
        }
    ];
    const resultData = useMemo(() => {
        if (!props?.selectedDetails) {
            return null;
        }
        return createStore({
            key: 'rowId',
            loadParams:
            {
                rIndetail: function () {
                    return props.formFields.TRANSACTIONTYPE===TransactionTypes.Receipt? props?.selectedDetails.rowid: null;
                },
                rOutDetail: function () {
                    return props.formFields.TRANSACTIONTYPE===TransactionTypes.Shipment?props?.selectedDetails.rowid :null;
                },
                subDetailId: function () {
                    return props?.subDetailId;
                },
                sort: JSON.stringify([{ selector: "serialnumber", desc: false }])
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.GetSerialNumberByItemDetails}`,
            insertUrl: `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.InsertSerialNumber}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.UpdateSerialNumber}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        })
    }, [props.selectedDetails]);
    const deleteRecords = useCallback(() => {

        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.DeleteSerialNumber}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }, [selectedItemKeys]);

    const onSelectionChanged = (e) => {
        setSelectedItemKeys(e.selectedRowKeys);
        if (e.selectedRowsData[0]) {
            setformFields(prev => ({
                ...prev,
                RowId: e.selectedRowKeys[0] && e.selectedRowKeys.length > 0 ? e.selectedRowKeys[0] : null,
                Damageflag: e.selectedRowsData[0]?.damageflag,
                Comment: e.selectedRowsData[0]?.comment,
                Damagedescription: e.selectedRowsData[0]?.damagedescription,
                OriginalNetWeight: e.selectedRowsData[0]?.originalNetWeight,
                OriginalGrossWeight: e.selectedRowsData[0]?.originalGrossWeight,
                Packageid: e.selectedRowsData[0]?.packageid,
                UserDefinedRefrence2: e.selectedRowsData[0]?.userDefinedRefrence2,
                UserDefinedRefrence3: e.selectedRowsData[0]?.userDefinedRefrence3,
                UserDefinedRefrence4: e.selectedRowsData[0]?.userDefinedRefrence4,
                UserDefinedRefrence5: e.selectedRowsData[0]?.userDefinedRefrence5,
                IsUpdateCall: false,
            }));
            if (formRefs.current.Damageflag && formRefs.current.Damageflag.instance) {
                formRefs.current.Damageflag.instance().option({
                    dataSource: OptionsNoYes,
                    valueExpr: "key",
                    displayExpr: "value",
                    value: formFields.Damageflag || null
                });
            }
        }
    }
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const rowInserting = (e) => {
        e.data['rIndetail'] = props?.rIndetail;
        e.data['rInSubDetail'] = props?.subDetailId;
        e.data['rItem'] = props?.itemRowId;
        e.data['rLot'] = props?.lotRowId;
        e.data['intransactionnumber'] = props?.formFields.TRANSACTIONNUMBER;
        e.data['intransactiondate'] = props?.formFields.TRANSACTIONDATE;
    }
    const rowUpdating = (e) => {
        e.newData['rIndetail'] = props?.rIndetail;
        e.newData['rInSubDetail'] = props?.subDetailId;
        e.newData['rItem'] = props?.itemRowId;
        e.newData['rLot'] = props?.lotRowId;
        e.newData['intransactionnumber'] = props?.formFields.TRANSACTIONNUMBER;
        e.newData['intransactiondate'] = props?.formFields.TRANSACTIONDATE;
    }
        const onEditingStart = (e) => {
        if(e.key != null && e.key != undefined && !dataGrid.current.instance().isRowSelected(e.key))
        {
            dataGrid.current.instance().selectRows([e.key], false);
        }
    };
    useEffect(() => {
        if (selectedItemKeys.length > 0 && props.profile.Showserialnopopup === Options.Yes) {
            setShowSerialNumberForm(true);
        }
    }, [selectedItemKeys])
    useEffect(() => {
        if (formFields.RowId && formFields.IsUpdateCall) {
            const formData = new FormData();
            formData.append("key", formFields.RowId);
            formData.append("values", JSON.stringify(formFields));
            axios.put(
                `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.UpdateSerialNumber}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
                .then((res) => {
                })
                .catch((err) => {
                    alert(err, "Error");
                });
        }
    }, [formFields])
    useEffect(() => {
        if (!showSerialNumberForm) {
            dataGrid.current.instance().refresh();
        }
    }, [showSerialNumberForm]);

    const handleFieldChange = useCallback((name, value, e) => {
        if (e.event) {
            setformFields(prevState => {
                return {
                    ...prevState,
                    [name]: value,
                    IsUpdateCall: true,
                };
            });
        }
    }, []);
    return (
        <>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys[0]}
                dataSource={resultData}
                showBorders={true}
                columnAutoWidth={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                remoteOperations={true}
                hoverStateEnabled={true}
                onRowInserting={rowInserting}
                onRowUpdating={rowUpdating}
                onSelectionChanged={onSelectionChanged}
                onContentReady={onContentReady}
                onEditingStart={onEditingStart}
                height="100%"
            >
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                    allowAdding={!props.disableGridsForRFTransactions && !props.isCommittedTransaction}
                />
                <Selection mode="single" />
                <ColumnHeaderFilter />
                <Sorting visible={true} mode="multiple" />
                <LoadPanel enabled={true} />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Grouping autoExpandAll={false} />
                <Column dataField="serialnumber" caption="Serial #" dataType="string" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Serialnumber.GetSerialNumberByItemDetails}`,
                        key: "serialnumber",
                        displayExpr: "serialnumber",
                        valueExpr: "serialnumber",
                        accessToken: accessToken,
                        loadParams:
                        {
                            rIndetail: function () {
                                return props?.rIndetail;
                            },
                        },
                        sort: [{ selector: "serialnumber", desc: false }],
                        defaultValue: cellElement.data.serialnumber,
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                        acceptCustomValue: true
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.serialnumber = newValue.text;
                    }} />
                <Column dataField="netweight" caption="Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                <Column dataField="grossweight" caption="Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                <Column dataField="size1" caption="Size - 1" dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                <Column dataField="size2" caption="Size - 2" dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                <Column dataField="receiptverified" caption="Rec Verify" dataType="string" >
                    <Lookup
                        dataSource={flags}
                        valueExpr="flagvalue"
                        displayExpr="flagdescription"
                    />
                </Column>
                <Column dataField="shipmentverified" caption="Ship Verify" dataType="string" allowEditing={false} >
                    <Lookup
                        dataSource={flags}
                        valueExpr="flagvalue"
                        displayExpr="flagdescription"
                    />
                </Column>
                <Column dataField="userDefinedRefrence1" caption="Reference 1" dataType="string" />
                <Column dataField="damageflag" caption="Damage Flag" dataType="string" >
                    <Lookup
                        dataSource={flags}
                        valueExpr="flagvalue"
                        displayExpr="flagdescription"
                    />
                </Column>
                <Column dataField="damagedescription" caption="Damage Description" dataType="string" />
                <Column dataField="outtransactionnumber" caption="Out Trans #" dataType="string" allowEditing={false} />
                <Column dataField="intransactionnumber" caption="In Trans #" dataType="string" allowEditing={false} />
                <Column dataField="outtransactiondate" caption="Out Trans Date" dataType="date" allowEditing={false} />
                <Column dataField="sublotcode" caption="Sublot Code" dataType="string" allowEditing={false} />
                <Toolbar>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length || props.disableGridsForRFTransactions === true || props.isCommittedTransaction === true}
                        />
                    </Item>
                </Toolbar>
            </DataGrid>
            {showSerialNumberForm && (
                <Popup
                    visible={showSerialNumberForm}
                    onHiding={() => setShowSerialNumberForm(false)}
                    dragEnabled={true}
                    closeOnOutsideClick={true}
                    showCloseButton={true}
                    title="WM Serial Numbers"
                    width={400}
                    height="auto"
                >
                    {SerialNumberForm.fields.map((field, idx) => (
                        <div style={{marginBottom:"1.4rem"}} key={idx + field.name}>
                            {Fields(field, formFields, handleFieldChange, false, false, formRefs)}
                        </div>
                    ))}
                </Popup>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(SerialNumbersTab);